function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 3");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Screens",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(2.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  stroke: "#000000",
  strokeWidth: 3,
  points: "43 0 43 17 58 17"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.4943163,25.9740898 C23.2312439,25.9740898 18.9457616,30.2687067 18.9457616,35.5429975 L22.1286132,35.5429975 C22.1286132,32.0230065 24.9818123,29.1637257 28.4943163,29.1637257 L28.4943163,25.9740898 Z M20.5485547,63.7484923 C20.5485547,64.0674559 20.6394933,64.3636364 20.8100032,64.6256422 L23.2426112,68.2937235 C23.5381617,68.7379942 24.0383241,69 24.5612212,69 L32.4046768,69 C32.9389412,69 33.4391036,68.7379942 33.7232868,68.2937235 L36.1558948,64.6256422 C36.3264047,64.3636364 36.4173433,64.0560643 36.4173433,63.7484923 L36.4173433,59.4424838 L20.5371874,59.4424838 L20.5485547,63.7484923 Z M28.4943163,18 C18.3205586,18 11,26.2702703 11,35.531606 C11,39.95153 12.6368951,43.9841412 15.3309516,47.0712531 C16.9905814,48.9622515 19.5823319,52.9265133 20.5371874,56.2528479 L20.5371874,56.2642394 L25.3114648,56.2642394 L25.3114648,56.2528479 C25.3114648,55.7744025 25.2432608,55.3073487 25.0954855,54.8516864 C24.5384865,53.0746035 22.8220201,48.4040652 18.9116596,43.9271834 C16.8655408,41.5919142 15.7742774,38.6301094 15.7742774,35.5429975 C15.7515427,28.2068349 21.7080221,22.7844539 28.4943163,22.7844539 C35.5079571,22.7844539 41.2257226,28.5030154 41.2257226,35.5429975 C41.2257226,38.6301094 40.1117246,41.6033058 38.076973,43.9271834 C34.1893472,48.3698906 32.4728808,53.0404289 31.9045145,54.8289033 C31.7567392,55.2845656 31.6885352,55.7744025 31.6885352,56.2528479 L31.6885352,56.2642394 L36.4628126,56.2642394 L36.4628126,56.2642394 C37.4290354,52.9379048 40.020786,48.9736431 41.6690484,47.0826446 C44.3631049,43.9955327 46,39.9629216 46,35.5429975 C45.9886327,25.8487827 38.1565443,18 28.4943163,18 Z",
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  stroke: "#000000",
  strokeWidth: 3,
  points: "58 78 0 78 0 0 42.8642308 0 58 16.0243056"
})));

var SvgUnderstandingIdeation = function SvgUnderstandingIdeation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "82px",
    viewBox: "0 0 62 82",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnderstandingIdeation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Understanding-ideation.91c779a2.svg";
export { ForwardRef as ReactComponent };